<template lang="html">
  <svg height="10" width="100%"
    id="thick-line"
    data-name="thick-line">
    <line x1="0" y1="0" x2="100%" y2="0" />
  </svg>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
  #thick-line {
    stroke: var(--blue);
    stroke-width:3;
  }
</style>
